import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal  } from '@azure/msal-react';
import { accessHelper, accessHelperText } from '../util/checkAccess';
import React, { useEffect, useState } from 'react';
import "./Home.css"
import HeurigenList from './HeurigenList';

function Home (){

    const { instance, accounts, inProgress } = useMsal();
    const [idToken, setIdToken] = useState("");
    const [accessToken, setAccessToken] = useState(null);    
   // const [editPermissionText, setEditPermissionText] = useState(null);

    const Login = async () => {        
        try {
            // let {idToken} = await instance.loginPopup();
            let {idToken} = await instance.loginRedirect();
            setIdToken(idToken);
        } catch (error) {
            console.error(error);
        }        
    }

    const Logout = async () => {
        try {
            // await instance.logoutPopup();
            await instance.logoutRedirect();
            
            setIdToken("")
        } catch (error) {
            console.error(error);
        }
    }

    const editPermissionText = accessHelperText(accounts[0]);

    useEffect(() => {                
        // loadFromDb();
    }, []); 


    return (
        <div className="home"> 
                <p className="text-left fw-bold pt-3">
                    Editor für Heurigenöffnungszeiten<br></br>
                    Klosterneuburg
                </p>
            <AuthenticatedTemplate>
                
                <div className="alert alert-success" role="alert">
                   Sie sind angemeldet! 😊 mit: <b>{accounts[0]?.username}</b> @ {accounts[0]?.idTokenClaims.state} Berechtigung: {editPermissionText} <button type="button" className="btn btn-dark btn-sm float-end" onClick={() => Logout()}>Abmelden</button>                   
                </div>  
                                
                <HeurigenList currentAccount={accounts[0]}></HeurigenList>
                <p></p>              
                
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <div className="alert alert-warning" role="alert">
                    Sie sind nicht angemeldet 🥺
                    <button type="button" className="btn btn-dark btn-sm float-end" onClick={() => Login()}>Login</button>
                </div>
            </UnauthenticatedTemplate>
        </div>
    )
}

export default Home;